import { quickAddActionCreators } from '@app/components/QuickAddModal/modules/quickAdd'
import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IGlobalCompaniesState,
  selectCompanyList,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { CompanySelector } from '../components/CompanySelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalCompaniesState>({
    companies: selectCompanyList(),
  }),
  { ...actionCreators, ...quickAddActionCreators },
)(CompanySelector)
